<template>
  <div>
    <hg-dialog :title="title" :width="500" :height="300" :visible.sync="show" @close="handleClose">
      <el-form :model="dataForm" size="mini"  :rules="rules" ref="ruleForm" label-width="100px" class="add-box">
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="系统名称" prop="name">
              <el-input v-model="dataForm.name" maxlength="50" :disabled="!isEdit"></el-input>
            </el-form-item>
            <el-form-item label="路径" prop="path">
              <el-input v-model="dataForm.path" :disabled="!isEdit"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="dataForm.remark" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="hg-dialog-footer">
        <el-button v-if="isEdit" type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button v-else type="primary" @click="edit" size="small" icon="el-hg-icon-edit">修 改</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>

import HgDialog from '@/components/dialog';

export default {
  name: 'edit',
  components: { HgDialog },
  props: {
    data: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      String,
      default: '系统详情'
    },
    isEdit: {
      String,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        name: [{
          required: true,
          message: '请输入系统名称',
          trigger: 'blur'
        }],
        path: [{
          required: true,
          message: '请输入路径',
          trigger: 'blur'
        }]
      },
      dataForm: {
        name: '',
        id: '',
        path: '',
        remark: '',
        updateFlg: 'update'
      }
    };
  },
  methods: {
    edit() {
      this.$emit('update:isEdit', true);
      this.$emit('update:title', '系统编辑');
    },
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.updateSystem();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async updateSystem() {
      const res = await this.$services.postJson({
        type: 'SYSTEMOPERATION',
        url: 'saveSystem',
        params: {
          name: this.dataForm.name,
          id: this.dataForm.id,
          path: this.dataForm.path,
          remark: this.dataForm.remark,
          updateFlg: 'update'
        }
      });
      if (res.status) {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    },
    async getOperationDetail() {
      const { status, bean } = await this.$services.post({
        type: 'SYSTEMOPERATION',
        url: 'getOperationDetail',
        params: {
          id: this.data.id
        }
      });
      if (status) {
        this.dataForm = bean;
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
        this.getOperationDetail();
      }
    }
  }
};
</script>
